import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import { Node } from 'slate';
import detectIndent from 'detect-indent';
import { SfEditor } from '../../custom/custom';
import getEventTransfer from '../../custom/get-event-transfer';
import { normailizeSelection } from '../selection-utils';
var CodeUtils = /*#__PURE__*/function () {
  function CodeUtils(editor) {
    var _this = this;
    _classCallCheck(this, CodeUtils);
    this.isInCodeBlock = function () {
      var block = SfEditor.match(_this.editor, _this.editor.selection.anchor, 'block');
      var blockParent = Node.parent(_this.editor, block[1]);
      if (blockParent.type === 'code_block') return true;
      return false;
    };
    this.getIndent = function (text) {
      return detectIndent(text).indent;
    };
    this.insertIndent = function (indent) {
      SfEditor.insertText(_this.editor, indent, {
        at: _this.editor.selection
      });
    };
    this.wrapCodeBlock = function () {
      normailizeSelection(_this.editor);
      SfEditor.setNodes(_this.editor, {
        type: 'code_line'
      }, {
        match: 'block',
        at: _this.editor.selection
      });
      SfEditor.wrapNodes(_this.editor, {
        type: 'code_block',
        children: [],
        data: {}
      });
      SfEditor.collapse(_this.editor, {
        edge: 'end'
      });
    };
    this.splitCodeLine = function () {
      var block = SfEditor.match(_this.editor, _this.editor.selection, 'block');
      var indent = _this.getIndent(Node.text(block[0]));
      SfEditor.splitNodes(_this.editor, {
        split: true,
        always: true,
        at: _this.editor.selection
      });
      _this.insertIndent(indent);
    };
    this.unwrapCodeBlock = function () {
      var split = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var codeBlock = SfEditor.match(_this.editor, _this.editor.selection, {
        type: 'code_block'
      });
      var codeBlockPath = codeBlock[1];

      // unwrap whole code block 
      if (!split) {
        codeBlock[0].children.forEach(function (codeLine, index) {
          var path = [].concat(_toConsumableArray(codeBlockPath), [index]);
          SfEditor.setNodes(_this.editor, {
            type: 'paragraph'
          }, {
            at: path
          });
        });
      } else {
        // unwrap a code line
        SfEditor.setNodes(_this.editor, {
          type: 'paragraph'
        }, {
          at: _this.editor.selection,
          match: 'block'
        });
      }
      SfEditor.unwrapNodesByTypeAtRange(_this.editor, {
        at: _this.editor.selection,
        split: split,
        match: {
          type: 'code_block'
        }
      });
    };
    this.editor = editor;
  }
  _createClass(CodeUtils, [{
    key: "pasteContentInCodeBlock",
    value: function pasteContentInCodeBlock(command) {
      var _this2 = this;
      var data = command.data;
      var _getEventTransfer = getEventTransfer(data),
        text = _getEventTransfer.text,
        fragment = _getEventTransfer.fragment,
        type = _getEventTransfer.type;
      if (text.length === 0) return;
      if (type === 'text' || type === 'html') {
        var codeLineFragment = text.split(/\r\n|\n/).map(function (textLine) {
          return {
            type: 'code_line',
            children: [{
              text: textLine
            }]
          };
        });
        SfEditor.insertFragment(this.editor, codeLineFragment);
        return;
      }
      fragment.map(function (node, index) {
        if (node.type === 'code_block') {
          node.children.forEach(function (codeLine, index1) {
            if (index1 === 0) {
              SfEditor.insertText(_this2.editor, Node.text(codeLine));
              return;
            }
            SfEditor.insertNodes(_this2.editor, codeLine);
          });
          return true;
        }
        if (index === 0) {
          SfEditor.insertText(_this2.editor, Node.text(node));
        } else {
          SfEditor.insertNodes(_this2.editor, {
            type: 'code_line',
            children: [{
              text: Node.text(node)
            }]
          });
        }
        return true;
      });
    }
  }]);
  return CodeUtils;
}();
export default CodeUtils;